import { jwtDecode } from 'jwt-decode';
import * as Env from 'widget/env';

const getIsMsgOutgoing = (
  accessToken: string | null | undefined,
  msg: Env.Message | undefined,
) => {
  if (!accessToken) return false;
  else if (!msg) return false;

  const user = jwtDecode<Env.User>(accessToken);
  const isMsgOutgoing = msg.sender_id == user.user_id;

  return isMsgOutgoing;
};

export default getIsMsgOutgoing;
